export const REELS_SCROLL_SWITCH_COOLDOWN = 800; // ms
export const REELS_SWIPE_THRESHOLD = 50; // px
export const REELS_PLAY_STATUS_INDICATOR_DURATION = 500; // ms
export const REELS_UNMUTE_TOAST_DURATION = 4000; // ms
export const REELS_LOCAL_VIDEOS_COUNT = 9;

export const REELS_WHEEL_SCROLL_THRESHOLD = 30;
export const MAX_PROGRESS_PERCENT = 100;
